// Budget settings constants
export const BUDGET_DEFAULTS = {
	MONTHLY_BUDGET: 10_000,
} as const;
